<template>
<main>
    <h1>Methoden</h1>
  </main>

</template>

<script>
export default {
  name: "Methoden", //this is the name of the component
  
  mounted () {
    // From testing, without a brief timeout, it won't work.
    if (this.$route.hash) {
      setTimeout(() => this.scrollTo(this.$route.hash), 1)
    }
  },
  created() {
    // Watch URL changes Hashs - scrollTo
    this.$watch(
      () => this.$route.hash,
      () => {
        setTimeout(() => this.scrollTo(this.$route.hash), 1)
      }
    )
  },
  methods: {
    scrollTo: function (hashtag) {
      setTimeout(() => { location.href = hashtag }, 1)
    },

    scrollToAnchorPoint(refName) {
        const el = this.$refs[refName]
        el.scrollIntoView({ behavior: 'smooth'})
    }
  
  },
  metaInfo() {
      return { 
          title: "Methoden",
          meta: [
            { name: 'description', content: 'Besser reiten mit Neuro-Athletik Training' },
            { property: 'og:title', content: "Besser reiten mit Neuro-Athletik Training"},
            { property: 'og:description', content: 'Beim Neuro-Training wird das Gehirn trainiert. Durch die Förderung von intuitiven Abläufen erfolgt eine schnellere und präzisere Reaktion, die dir vor allem am Pferd zugute kommen.'}, 
            { property: 'og:image', content: '../assets/img/neuro/brock-pferd.png'},
            { property: 'og:url', content: 'www.pferdeverstand.at/neuro'}

          ]
      }
  }
};

//TODO meta daten
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Methoden.vue